export const uniqSort = <T>(xs: T[], compare: (a: T, b: T) => number) => {
  const sorted = xs.sort(compare);
  return sorted.filter((xs, index) => index === 0 || compare(sorted[index - 1], xs) !== 0);
};
